import $ from 'jquery'
import { spin } from './_site'
require('fancybox')

export const changeImage = ($el) => {
  var $img = $el.children(),
    imgSrc = $img.data('img'),
    $gallery = $el.closest('.product-gallery'),
    $galleryStage = $gallery.find('.product-gallery-stage'),
    $stageImg = $galleryStage.find('img'),
    newImg = new Image(),
    galleryStageClass = 'product-gallery-stage',
    galleryItemClass = 'product-gallery-list__item',
    galleryItemActiveClass = galleryItemClass + '--active',
    spinner = $.extend(true, {}, spin)

  if ($el.hasClass('product-gallery-list__item--gallery')) return

  // loading
  $.extend(spinner, {
    color: '#000',
    top: '50%',
    left: '50%',
    width: 10,
    radius: 15,
  })

  function toggleLoader(flag) {
    if (flag) {
      // add loader
      $galleryStage.addClass(galleryStageClass + '--loading')
      // $galleryStage.spin(spinner);
    } else {
      // remove loader
      $galleryStage.removeClass(galleryStageClass + '--loading')
      // $galleryStage.spin(false);
    }
  }

  // load img
  newImg.onload = function () {
    $stageImg.fadeOut().queue(function () {
      toggleLoader(false)

      $(this)[0].src = newImg.src
      $(this).fadeIn()
      $(this).dequeue()
    })
  }
  newImg.src = imgSrc

  // append loader
  toggleLoader(true)

  // set active
  $el.addClass(galleryItemActiveClass).siblings().removeClass(galleryItemActiveClass)
}
export const openGallery = ($el) => {
  var $gallery = $el.closest('.product-gallery'),
    $hiddenGallery = $gallery.find('.product-gallery-hidden'),
    index = $('.product-gallery-list__item--active').index('.product-gallery-list__item'),
    $trigger = $hiddenGallery.children().eq(index)

  $trigger.trigger('click')
}
export const binds = ($el) => {
  // ---------------- open gallery
  $('#wrapper').on('click.products', '.product-gallery__zoom', function (event) {
    event.preventDefault()
    openGallery($(this))
  })

  // ---------------- change filter
  $('#wrapper').on(
    'click.products-gallery',
    '.product-gallery-list__item:not(.product-gallery-list__item--active)',
    function () {
      changeImage($(this))
    }
  )
}
